<template>
    <ToolButton :Editor="Editor" KnownIcon="TableInsertColumnRight"
        @ToolClick="Editor.chain().focus().addColumnAfter().run()">
    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>